/* modules imports */
import styled from "styled-components";

export const StyledHyperlink = styled.a`
  color: var(--color-pink);

  &:link, &:visited, &:active { text-decoration: none; }
  &:hover { text-decoration: underline; }
`;
